import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=4dcf277d&scoped=true&"
import script from "./checkbox.ts?vue&type=script&lang=ts&"
export * from "./checkbox.ts?vue&type=script&lang=ts&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=4dcf277d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf277d",
  null
  
)

export default component.exports